"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-foreground transition-colors duration-[var(--duration-medium)]">
                  {item.label}
                  <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden z-50">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map(item => <li key={item.id}>
                  <Link to={item.href || "#"} className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-accent rounded-md transition-colors duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-16 bg-background/95 backdrop-blur-sm shadow-medium" : "h-[88px] bg-background"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-8">
        {}
        <Link to="/" className="shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/oryx_fleet_logo.png" alt="Oryx Fleet LLC" className="h-7 transition-all duration-[var(--duration-medium)]" />
        </Link>

        {}
        <MenuProvider menu_id="3" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden md:inline-flex hover:!bg-primary-hover focus:!bg-primary-hover hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
          <Link to="/ContactUsPage">Start Dispatching</Link>
        </Button>
      </div>
    </header>;
}